/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Saved_SuccessInputs */

const en_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project saved successfully`)
};

const fr_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet enregistré avec succès`)
};

const de_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt erfolgreich gespeichert`)
};

const it_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto salvato con successo`)
};

const ru_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект успешно спасен`)
};

const es_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto guardado exitosamente`)
};

const zh_cn2_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目已成功保存`)
};

const ja_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトが正常に保存されました`)
};

const hi_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_project_saved_success = /** @type {(inputs: Project_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto salvo com sucesso`)
};

/**
* | output |
* | --- |
* | "Project saved successfully" |
*
* @param {Project_Saved_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_saved_success = /** @type {((inputs?: Project_Saved_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Saved_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_saved_success(inputs)
	if (locale === "de") return de_project_saved_success(inputs)
	if (locale === "it") return it_project_saved_success(inputs)
	if (locale === "ru") return ru_project_saved_success(inputs)
	if (locale === "es") return es_project_saved_success(inputs)
	if (locale === "zh-CN") return zh_cn2_project_saved_success(inputs)
	if (locale === "ja") return ja_project_saved_success(inputs)
	if (locale === "hi") return hi_project_saved_success(inputs)
	if (locale === "pt-PT") return pt_pt2_project_saved_success(inputs)
	return en_project_saved_success(inputs)
});